import { render, staticRenderFns } from "./ChartReferralScore.vue?vue&type=template&id=56ddbf6a&"
import script from "./ChartReferralScore.vue?vue&type=script&lang=ts&"
export * from "./ChartReferralScore.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports